import React from 'react'
import Monthly from './Monthly'

const YearlyPricing = () => {
  return (
    <div>
        <Monthly display='text-lemon text-xs' standard = {65} premium = {100}/>
    </div>
  )
}

export default YearlyPricing